import * as ActionTypes from './ActionTypes';

export const Months = (state = {
        errMess: null,
        months: []
    }, action) => {
    switch(action.type) {
        case ActionTypes.ADD_MONTHS:
            return {...state, isLoading: false, errMess: null, months: action.payload};

        case ActionTypes.MONTHS_FAILED:
            return {...state, isLoading: false, errMess: action.payload, months: []};

        case ActionTypes.ADD_MONTH:
            var month = action.payload;
            return {...state, months: state.months.concat(month)};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/months.js